import { CareerFeedAiAssistantInitialState } from '../CareerFeedAiAssistantInitialState/CareerFeedAiAssistantInitialState';
import { CareerFeedAssistantQuestions } from '../CareerFeedAssistantQuestions/CareerFeedAssistantQuestions';
import { useCareerFeedAIAssistant } from '../hooks/useCareerFeedAIAssistant';

import { RecommendationRefinedConfirmation } from './CareerFeedAIAssistantRecommendationRefinedConfirmation';
import { ConversationFinished } from './ConversationFinished';

export const CareerFeedAIAssistantContent = () => {
  const { progress } = useCareerFeedAIAssistant();

  switch (progress) {
    case 'initial':
      return <CareerFeedAiAssistantInitialState />;
    case 'recsRefined':
      return <ConversationFinished />;
    case 'recsRefined-withPersistedData':
      return <RecommendationRefinedConfirmation />;
    case 'gatheringRefinement':
    case 'collectGeneralRequirementsAtLast':
      return <CareerFeedAssistantQuestions />;
  }
};
